import { setToken, removeToken, getToken } from '@/utils/auth'

const state = {
  token:getToken() || '', //共享的 token
}
const mutations = { 
  // 对token进行赋值
  setToken(state,token) {
    state.token = token
    // 将token 持久化存储到本地
    setToken(token)
  },
  // 移除token
  removeToken(state) {
    state.token = ''
    removeToken()
  }
}
const actions = {}

export default {
  namespaced:true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js